import React, { useEffect, useState } from "react";
import { Container, Title, TextInput, LoadingOverlay, Alert, Button, Group } from '@mantine/core';
import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { useMatch, useNavigate } from "@tanstack/react-location";
import { CountrySelect } from "./../components";
import * as App from "../model/App";

export default function ClientScreen() {
    const { params: { id } } = useMatch();
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const { isLoading, isError, data } = useQuery([`client_${id}`], async () => { 
        const userID = await App.Firebase.Auth.getEffectiveUserID() || "";
        return App.Firebase.Read.getClientById(userID, id); 
    });
    const [agent, setAgent] = useState<string>("");
    const [attorney, setAttorney] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [country, setCountry] = useState<string>("");

    useEffect(() => {
        if (data) {
            setAgent(data.agent);
            setAttorney(data.attorney);
            setEmail(data.email);
            setCountry(data.country);
        }
    }, [data]);

    const saveClient = useMutation(async () => { 
        const client: App.Data.App.IClient = { agent, attorney, email, country };
        const userID = await App.Firebase.Auth.getEffectiveUserID() || "";
        return App.Firebase.Write.updateClient(userID, id, client); 
        }, { onSuccess: () => { queryClient.invalidateQueries([`client_${id}`]); } }
    );

    return (
        <Container ml={0}>
            <Group position="apart">
                <Title>Client Details</Title>
            </Group>

            <LoadingOverlay visible={isLoading || saveClient.isLoading} />
            {isError && <Alert color="red" title="Error">Error loading data</Alert>}
            {saveClient.isError && <Alert color="red" title="Error">Error saving client</Alert>}

            {data &&
                <>
                <TextInput label="Agent" value={agent} onChange={(event) => { setAgent(event.target.value); }} my={10} />
                <TextInput label="Attorney" value={attorney} onChange={(event) => { setAttorney(event.target.value); }} my={10} />
                <TextInput label="Email" value={email} onChange={(event) => { setEmail(event.target.value); }} my={10} />
                <CountrySelect value={country ?? ""} label="Country" placeholder="Country" onChange={(value) => { setCountry(value); }} />
                <Button my={10} onClick={() => { saveClient.mutate(); navigate({ to: "/clients" }); }}>Save</Button>
                </>
            }
        </Container>
    );
}